import { apiFetch, jsonOpts, parseJson } from "./client";
import type { DealerTechnician, DealerTechnicianInput } from "./types";

/** The backend matches ignoring case and accents. */
export async function searchDealerTechnicians(
  q: string
): Promise<DealerTechnician[]> {
  return parseJson<DealerTechnician[]>(
    await apiFetch(
      `/api/dealer-technicians?${new URLSearchParams({ q }).toString()}`
    )
  );
}

export async function createDealerTechnician(
  body: DealerTechnicianInput
): Promise<DealerTechnician> {
  return parseJson<DealerTechnician>(
    await apiFetch("/api/dealer-technicians", {
      ...jsonOpts,
      method: "POST",
      body: JSON.stringify(body),
    })
  );
}
